import React, {useState} from 'react';
import { SearchOutlined } from '@ant-design/icons';
import {Button, Input} from 'antd';


interface Props {
    search: (value: string) => void,
    current: string | null | undefined,
}

const SearchDropDown = (props: Props) => {
    const [search, setSearch] = useState<string>(props.current ? props.current : "");

    return (
        <form onSubmit={(e) => {
            e.preventDefault();
            props.search(search);

        }} style={{padding: 8}}
        >
            <Input
                placeholder='Search by order number'
                value={search}
                onChange={e => setSearch(e.target.value ? e.target.value : '')}
                style={{width: 188, marginBottom: 8, display: 'block'}}
            />
            <Button
                type="primary"
                htmlType="submit"
                icon={<SearchOutlined />}
                size="small"
                style={{width: 90, marginRight: 8}}
            >
                Search
            </Button>
            <Button
                onClick={() => {
                    setSearch("");
                    props.search("");
                }}
                size="small"
                style={{width: 90}}
            >
                Reset
            </Button>
        </form>
    );
};

export default SearchDropDown;
